import { render, staticRenderFns } from "./AdminRulesComponent.vue?vue&type=template&id=cf598e24"
import script from "./AdminRulesComponent.vue?vue&type=script&lang=js"
export * from "./AdminRulesComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminRulesComponent.vue?vue&type=style&index=0&id=cf598e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports